export default (state, action) => {
  const { status, message } = action.error ?? {};

  return {
    ...state,
    promoCodes: {
      ...state.promoCodes,
      serverError: {
        ...state.promoCodes.serverError,
        status,
        message,
      },
    },
    waiting: false,
  };
};
